module.exports = __webpack_public_path__ + "static/media/trash.0f469edd.svg";